import { createSlice } from '@reduxjs/toolkit'

const changePasswordSlice = createSlice({
    name: 'change-password',
    initialState: { error: null, loading: false, success: false },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setSuccess(state, action) {
            const { payload } = action

            state.success = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        changePassword() {},
    },
})

const { actions, reducer } = changePasswordSlice

export const { setLoading, setSuccess, setError, changePassword } = actions

export default reducer
